import type { RouteRecordRaw } from 'vue-router'

export const orderRoutes: RouteRecordRaw[] = [
	{
		path: '/objednavky',
		name: 'orders',
		component: () => import('./OrdersListPage.vue'),
		meta: { titleSk: 'Objednávky', requiresAuth: true },
	},
	{
		path: '/objednavky/:id',
		name: 'order-detail',
		component: () => import('./OrderDetailPage.vue'),
		meta: { titleSk: 'Detail objednávky', breadcrumbSk: ['Objednávky'], requiresAuth: true },
	},
]
